import { FC, Suspense } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { FiAlertTriangle } from 'react-icons/fi';
import { PictureLink } from '../../components/links/PictureLink';
import { Skeleton } from '../../components/loading/Skeleton';
import { Category } from '../../services/graph/hooks/sidecar.types';
import { useCategoryDetails } from '../../services/api/hooks/categories';

interface Props {
  categoryData: Category;
}

const CategoryCarouselLinkContent: FC<Props> = ({ categoryData }) => {
  const { imageUrl } = useCategoryDetails(categoryData.id); 

  if (!categoryData.name) {
    throw Error(`Category has no name`);
  }

  return (
    <PictureLink
      url={imageUrl}
      title={categoryData.name}
      description={categoryData.description}
      to={`documents/categories/${categoryData.id}`}
    />
  );
};

const CategoryCarouselLinkError: FC<FallbackProps> = ({ error }) => {
  return (
    <div className="h-52 w-full rounded-md relative flex items-center justify-center bg-red-300">
      <div className="font-semibold text-white text-lg absolute bottom-2 left-3 z-30">{`${error}`}</div>
      <FiAlertTriangle className="h-20 w-20 text-red-500" />
    </div>
  );
};

export const CategoryCarouselLink: FC<Props> = ({ categoryData }) => {
  return (
    <Suspense fallback={<Skeleton className="h-52 w-full rounded-md" />}>
      <ErrorBoundary fallbackRender={CategoryCarouselLinkError}>
        <CategoryCarouselLinkContent categoryData={categoryData} />
      </ErrorBoundary>
    </Suspense>
  );
};
